import {useMediaQuery, useTheme, Theme} from '@mui/material'

export type BreakPoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export const useWidth = () => {
  const theme = useTheme()
  const keys = [...theme.breakpoints.keys].reverse()
  return (
    keys.reduce<BreakPoint | null>((output, key) => {
      // eslint-disable-next-line react-hooks/rules-of-hooks
      const matches = useMediaQuery(theme.breakpoints.up(key))
      return !output && matches ? key : output
    }, null) || 'xs'
  )
}

export const useMobileBreakPoint = () =>
  useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'))
